<template>
<div>
  <el-container>
    <el-main>
      <el-form label-position="right" label-width="120px" v-if="fromData" :model="fromData">
        <el-form-item label="应用名称">
          <el-input size="mini" v-model="fromData.appName"></el-input>
        </el-form-item>
        <el-form-item label="应用LOGO">
<!--          <el-input size="mini" v-model="fromData.appLogo"></el-input>-->
          <el-upload
            :action="url"
            list-type="picture-card"
            :before-upload="upload"
            :on-remove="remove"
            :on-success="success"
            :file-list ="img">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="edtiConfig">保存设置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</div>
</template>

<script>
export default {
  name: "ConfigConfig",
  data(){
    return{
      url:'',
      url1:'',
      img:[],
      fromData:{
        appName:'',
        appLogo:''
      }
    }
  },
  mounted() {
    this.url = this.$myhttp.defaults.baseURL + "/admin/posts";
    this.url1 = this.$myhttp.defaults.baseURL;
    this.getData()
  },
  methods:{
    getData(){
      var that=this;
      that.$myhttp.get('admin/config/getConfig').then(({data}=ret)=>{
        if(data.code&&data.data){
          that.fromData=data.data;
          that.fromData.appLogo&&(this.img = [{name:'logo',url:this.url1+that.fromData.appLogo}]);
        }else {
          // that.$msgbox.alert(data.msg||'需要重新配置或者查询出现异常')
        }
      })
    },
    edtiConfig(){
      var that=this;
      that.$myhttp.post('admin/config/setConfig',that.fromData).then(({data}=ret)=>{
        if(data.code){
          that.$msgbox.alert('配置成功')
          ERP.initAPP();
        }else {
          that.$msgbox.alert(data.msg||'配置失败')
        }
      })
    },
    //点击上传
    upload(file){
      if(this.fromData.appLogo){
        this.$Message.error('头像只能上传一张');
        return false;
      }
    },
    //移除
    remove(file, fileList){
      this.fromData.appLogo = '';
    },
    //上传成功
    success(response, file, fileList){
      var img = this.url1+'/storage/'+file.response;
      this.img = [{name:'logo',url:img}];
      this.fromData.appLogo = '/storage/'+file.response;
      console.log(this.fromData.appLogo)
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 120px;
  height: 45px;
  line-height: 50px;
  vertical-align: top;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 120px;
  height: 45px;
  margin: 0 8px 8px 0;
  display: inline-block;
  //line-height: 45px;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/Config.vue